import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'itm-required',
	templateUrl: './itm-required.component.html',
	styleUrls: ['./itm-required.component.scss']
})
export class ItmRequiredComponent implements OnInit {

	constructor() { }

	ngOnInit() {
	}

}
